import {ADD_NEW_BRAND_SUCCESS, ADD_NEW_BRAND_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], errors: null };

export default function brandsManager(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_NEW_BRAND_SUCCESS:
      return { ...state, ids: action.payload.id, errors: null };
      //return { ...state, ids: action.payload, errors: null };
    case ADD_NEW_BRAND_FAILURE:
      return { ...state, errors: action.payload.response && action.payload.response.data.errors };
    default:
      return state;
  }
}
